module.exports = __webpack_public_path__ + "static/media/play-button.dfba8d43.png";